import AppSerializer from 'serializers/app';

class BankSerializer extends AppSerializer {
	constructor(store, props) {
		super(store, props);
	}

	get relationships() {
		return {
			provider: { serialize: 'id' },
		}
	}

}

export default BankSerializer;